import { LOGIN as r, LOGOUT as t } from "./types.js";
function n(o) {
  return {
    type: r,
    payload: o
  };
}
function p() {
  return {
    type: t
  };
}
export {
  n as loginUser,
  p as logoutUser
};
//# sourceMappingURL=actions.js.map
